import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx'
import Formsy from 'formsy-react';

import { Row, Col, Button, Label, FormGroup, SimpleAlert, Textarea, SheetFooter, SheetBody } from 'twyne-new.ui'

import Input from 'components/form/Input';
import Select from 'components/form/Select';

const MAX_LINES = 25000

const ValidatorFormPropTypes = {
  origin: PropTypes.string,
  handleSubmit: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  data: PropTypes.any
}

class ValidatorForm extends React.Component {
  state = {
    textValues: '',
    delimiter: '\n',
    data: [],
    disabled: true,
    blockInput: false
  }

  componentWillMount() {
    let data = this.props.data
    if (data)
      this.setState(toJS(data))
  }

  handleValidSubmit = (model) => {
    if (!this.props.entityOrigin)
      model = this.refs.form.getModel() || {}

    this.props.onSubmit(Object.assign(this.state, model))
  }

  validate = (model) => {
    const fields = Object.assign(this.state, model)
    const { name, data } = fields

    const condition = name !== '' && data.length
    let disabled = condition ? false : true

    if (disabled !== this.state.disabled)
      this.setState({ disabled })
  }

  parseText = (text, delimiter) => {
    return text.split(delimiter).map(line => line.trim()).filter(line => line !== '')
  }

  handleTextChange = (event) => {
    const { value: textValues } = event.target
    const { delimiter } = this.state
    const data = this.parseText(textValues, delimiter)

    if (data.length >= MAX_LINES && textValues.endsWith(delimiter)) {
      const valueMaxLine = this.removeMaxLines(textValues, delimiter)
      this.setState({ blockInput: true, data: data.slice(0, MAX_LINES), textValues: valueMaxLine })
    } else {
      this.setState({ textValues, data })
    }
  }

  removeMaxLines = (value, delimiter) => {
    const textSplited = value.split(delimiter)
    const textSliced = textSplited.slice(0, MAX_LINES)
    const textJoined = textSliced.join(delimiter)
    return textJoined
  }

  handleDelimiterChange = (option) => {
    const delimiter = option ? option.value : ''
    const data = this.parseText(this.state.textValues, delimiter)
    this.setState({ delimiter, data })
  }

  delimiterOptions = [
    { label: 'Line Break', value: '\n' },
    { label: 'Space', value: ' ' },
    { label: 'Comma', value: ',' },
    { label: 'Semicolon', value: ';'},
    { label: 'Tab', value: '\t'}
  ]

  CountValues = () => {
    const [count, setCount] = useState(0)
    const { data } = this.state
    let { delimiter } = this.state

    if (delimiter === '\n')
      delimiter = 'line break'
    else if (delimiter === '\t')
      delimiter = 'tab'
    else if (delimiter === ' ')
      delimiter = 'space'

    useEffect(() => {
      if(data)
        setCount(data.length)
    }, [data])

    return <SimpleAlert variant='info'>
      Contains {count}/{MAX_LINES}, separated by "<b>{delimiter}</b>"
    </SimpleAlert>
  }

  handleKeyDown = e => {
    if (e.key === 'Tab') {
      e.preventDefault()
      this.handleTextChange({ target: { value: `${this.state.textValues}\t` } })
    }
  }

  Data = () => {
    const { data, delimiter } = this.state

    useEffect(() => {
      if(data)
        this.setState({ textValues: data.join(delimiter) })
    }, [])

    return <Fragment>
      <Col size="12">
        <FormGroup>
          <Label>Delimiter</Label>
          <Select required
            name="delimiter"
            options={this.delimiterOptions}
            handleOnChange={this.handleDelimiterChange}
            value={this.state.delimiter}
          />
        </FormGroup>
      </Col>
      <Col size="12">
        <FormGroup>
          <Label>Values</Label>
          <Textarea
            name="textValues"
            type="textarea"
            onChange={this.handleTextChange}
            value={this.state.textValues}
            disabled={this.state.blockInput}
            onKeyDown={this.handleKeyDown}
            rows="10"
          />
        </FormGroup>
      </Col>
      <Col size="12">
        <this.CountValues/>
      </Col>
    </Fragment>
  }

  General = () => {
    return <Fragment>
      <Col size="12">
        <FormGroup>
          <Label>Name</Label>
          <Input required
            name="name"
            value={this.state.name || ''}
          />
        </FormGroup>
      </Col>
    </Fragment>
  }

  SubmitButton = () => {
    const props = { color: "accent" }

    if (this.props.entityOrigin) {
      props['type'] = "submit"
    } else {
      props['onClick'] = this.handleValidSubmit
      props['disabled'] = this.state.disabled
    }

    return <Button {...props}>Save</Button>
  }

  render() {
    return <Formsy ref="form" onValidSubmit={this.handleValidSubmit} onChange={this.validate}>
      <SheetBody>
        <Row>
          <this.General />
          <this.Data />
        </Row>
      </SheetBody>
      <SheetFooter>
        <Button onClick={this.props.onCancel} variant='ghost'>Cancel</Button>
        <this.SubmitButton />
      </SheetFooter>
    </Formsy>
  }
}

ValidatorForm.propTypes = ValidatorFormPropTypes

export default ValidatorForm;
